<template>
  <div class="report-card settle-bar" :class="{ 'is-stuck': isStuck }">
    <div class="settle-kpis">
      <div class="settle-kpi">
        <span class="settle-kpi__label">总收入</span>
        <b class="settle-kpi__value" :class="{ 'is-zero': !income }">{{ income | formatYuan }}</b>
      </div>
      <span class="settle-kpi__divider"/>
      <div class="settle-kpi">
        <span class="settle-kpi__label">
          总支出
          <el-tooltip placement="top">
            <div slot="content">
              退款类支出 {{ refund | formatYuan }} · 备用金支出 {{ reservePay | formatYuan }}
            </div>
            <i class="el-icon-info settle-kpi__hint"/>
          </el-tooltip>
        </span>
        <b class="settle-kpi__value" :class="{ 'is-zero': !expense }">{{ expense | formatYuan }}</b>
      </div>
      <span class="settle-kpi__divider"/>
      <div class="settle-kpi">
        <span class="settle-kpi__label">备用金期末</span>
        <b class="settle-kpi__value" :class="{ 'is-zero': !reserve }">{{ reserve | formatYuan }}</b>
      </div>
    </div>
    <div class="settle-actions">
      <slot name="actions"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DailyReportSummary',
  props: {
    // 数值都已经是「元」，组件只负责格式化，不再做分/元换算
    income: { type: Number, default: 0 },
    // 总支出 = 退款类支出 + 备用金支出
    expense: { type: Number, default: 0 },
    // 拆解给 tooltip 用
    refund: { type: Number, default: 0 },
    reservePay: { type: Number, default: 0 },
    reserve: { type: Number, default: 0 },
  },
  data: () => ({
    isStuck: false,
  }),
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 吸顶时元素 top 停在 0，未吸顶时大于 0
    handleScroll() {
      if (!this.$el) return;
      this.isStuck = this.$el.getBoundingClientRect().top <= 0;
    },
  },
};
</script>

<style src="../report-card.css"></style>

<style scoped>
.settle-bar {
  position: sticky;
  top: 0;
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  box-shadow: 0 6px 18px rgba(31, 45, 61, .06);
}

/* 吸顶后完全贴合顶部：去掉上/左右边框与圆角，只留底边和投影 */
.settle-bar.is-stuck {
  border-color: transparent;
  border-bottom-color: #ebeef5;
  border-radius: 0;
  box-shadow: 0 6px 16px rgba(31, 45, 61, .1);
}

.settle-kpis {
  display: flex;
  align-items: center;
}

.settle-kpi {
  display: flex;
  flex-direction: column;
}

.settle-kpi__label {
  margin-bottom: 2px;
  color: #909399;
  font-size: 12px;
}

.settle-kpi__hint {
  margin-left: 4px;
  color: #c0c4cc;
  cursor: help;
}

.settle-kpi__value {
  color: #1f2d3d;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
  font-feature-settings: 'tnum';
  letter-spacing: -.2px;
  user-select: all;
}

/* 0 值不抢视线：和「有金额」的指标拉开层级 */
.settle-kpi__value.is-zero {
  color: #c0c4cc;
  font-weight: 500;
}

.settle-kpi__divider {
  width: 1px;
  height: 32px;
  margin: 0 32px;
  background: #ebeef5;
}

.settle-actions {
  display: flex;
  align-items: center;
}

@media (max-width: 992px) {
  .settle-bar {
    flex-wrap: wrap;
  }

  .settle-kpi__divider {
    margin: 0 16px;
  }

  .settle-kpi__value {
    font-size: 20px;
  }

  .settle-actions {
    margin-top: 12px;
  }
}
</style>
